import AIInfluencer from "./components/AIInfluencer";
import ItemContainer from "./containers/ItemContainer";
import CreateItem from "./components/CreateItem";
import UpdateItem from "./components/UpdateItem";

const basePath = "/app/dashboard"
export const itemRoutesUrl ={
    AIInfluencer: `${basePath}/items/ai-influencer`,
    CreateItem: `${basePath}/createitem`,
    EditItem: `${basePath}/updateitem`,
    ListItems: `${basePath}/items`,
}

export const AiInfluencerBreadCrumb = [
    {
        label: "Items",
        href: itemRoutesUrl.ListItems,
    },
    {
        label: "AI Influencer", 
    }
]
//TODO: Fix routing and memory errors in ItemContainer, then use it, uncommented routes
const ItemRoutes = [
    {
        path: itemRoutesUrl.AIInfluencer,
        component: AIInfluencer,
    },
    {
        path: itemRoutesUrl.ListItems,
        component: ItemContainer,
    },
    {
        path: itemRoutesUrl.CreateItem,
        component: CreateItem,
    },
    {
        path: itemRoutesUrl.EditItem,
        component: UpdateItem,
    },
]

export default ItemRoutes;